import styled from 'styled-components';

import Picture from 'components/picture';

export const CartItemPrice = styled.span`
  font-weight: bold;
`;

export const UpsellRoot = styled.div`
  height: 80vh;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
`;

export const UpsellCartItemWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  gap: 16px;
  padding: 16px;
  position: relative;
`;

export const UpsellCartItemName = styled.span`
  font-size: 16px;
  text-align: center;
  font-family: ${Styles.fontFamily.brand};
  font-weight: ${Styles.fontWeight.normal};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  /*
  * Even if the -webkit-box-orient property is marked as non-standard by MDN (https://developer.mozilla.org/en-US/docs/Web/CSS/box-orient)
  * I didn't find another way of achieving vertical line clamp using CSS only.
  * The same property is used in around 15 files throughout the app.
  */
`;

export const UpsellCartItemPicture = styled(Picture)`
  aspect-ratio: 1;
  height: 100px;

  ${Styles.desktop} {
    height: 140px;
  }
`;

export const UpsellCartItemRow = styled.div`
  display: flex;
  gap: 4px;
`;

export const UpsellCartItemButtonContainer = styled.div`
  margin-block-start: auto;
  align-self: stretch;
`;

export const UpsellCartItemQuantityContainer = styled.div`
  margin-block-start: auto;
`;

export const UpsellCartItemCol = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
